// extracted by mini-css-extract-plugin
module.exports = {"background":"modal_background__1mX-R","visible":"modal_visible__13E52","modal":"modal_modal__1DF1f","header":"modal_header__2iX3r","content":"modal_content__1tQ-X"};